import { ExpandLess } from '@mui/icons-material';
import React, { ReactElement, ReactNode, useState } from 'react';
import Typography from '../../Typography/Typography';
import {
  StyledBody,
  StyledIcon,
  StyledSection,
  StyledSectionTitle,
} from './Section.style';
import { Collapse } from '@mui/material';
import { useTheme } from 'styled-components';
import DefaultUptimeTheme from 'component/theme/defaultTheme';

interface SectionProps {
  children: ReactNode;
  title: string;
  actionIcon?: ReactElement;
  disablePaddingBottom?: boolean;
  collapsible?: boolean;
  variant?: any;
  disabled?: boolean;
}

const Section = (props: SectionProps) => {
  const { title, actionIcon, children, disablePaddingBottom, collapsible, variant, disabled } = props;
  const theme = useTheme() as typeof DefaultUptimeTheme;
  const [isCollapse, setIsCollapse] = useState(false);

  const renderIcon = () => {
    if (collapsible) {
      return (
        <ExpandLess onClick={() => setIsCollapse(isCollapse => !isCollapse)} />
      );
    }

    return actionIcon;
  };

  const showIcon = collapsible || actionIcon;

  return (
    <StyledSection className="section">
      <StyledSectionTitle>
        <Typography variant={variant} fontSize={theme.uptimeFontSizes.desktop.fz5}>{title}</Typography>

        {showIcon && (
          <StyledIcon collapse={collapsible && isCollapse} id={collapsible ? "btn-orderrequest-option_detail" : "btn-orderrequest-view_address_detail"} disabled={disabled} aria-label={collapsible ? "Option Detail Button" : "Shipping To Button"}>
            {renderIcon()}
          </StyledIcon>
        )}
      </StyledSectionTitle>

      <Collapse in={!collapsible || !isCollapse}>
        <StyledBody disablePaddingBottom={disablePaddingBottom}>
          {children}
        </StyledBody>
      </Collapse>
    </StyledSection>
  );
};

export default Section;
